// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/**
 * 获取完整的省市区树形结构
 * GET /api/regions/tree
 * 注意：此接口返回约3400条数据，建议前端缓存
 */
export async function getRegionTree(options?: { [key: string]: any }) {
  return request<BILLIARD.RegionResult<BILLIARD.Region[]>>('/api/regions/tree', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 查询所有省份
 * GET /api/regions/provinces
 */
export async function getProvinces(options?: { [key: string]: any }) {
  return request<BILLIARD.RegionResult<BILLIARD.Region[]>>('/api/regions/provinces', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 根据父级ID查询子地区
 * GET /api/regions/children
 */
export async function getChildrenByParentId(
  parentId: number,
  options?: { [key: string]: any },
) {
  return request<BILLIARD.RegionResult<BILLIARD.Region[]>>('/api/regions/children', {
    method: 'GET',
    params: { parentId },
    ...(options || {}),
  });
}

/**
 * 根据编码查询地区
 * GET /api/regions/code/{code}
 */
export async function getRegionByCode(
  code: string,
  options?: { [key: string]: any },
) {
  return request<BILLIARD.RegionResult<BILLIARD.Region>>(`/api/regions/code/${code}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 根据层级查询地区
 * GET /api/regions/level/{level}
 * @param level 层级：1-省，2-市，3-区
 */
export async function getRegionsByLevel(
  level: number,
  options?: { [key: string]: any },
) {
  return request<BILLIARD.RegionResult<BILLIARD.Region[]>>(`/api/regions/level/${level}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export default {
  getRegionTree,
  getProvinces,
  getChildrenByParentId,
  getRegionByCode,
  getRegionsByLevel,
};
